import React, { useEffect, useMemo } from "react";
import { useState } from "react";
import { TemplateSelector } from "./pages/TemplateSelector";
import { CVUploader } from "./pages/CVUploader";
import { PopupWrapper } from "../../../../../../../components/popupWrapper";
import { ReactComponent as CloseIcon } from "../../../../../../../assets/close.svg";
import { CvCheckCoach, TemplatePreview } from "./pages/TemplatePreview";
import SuccessPage from "./pages/Success";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import {
  fetchCvCheckCoaches,
  getAvailableTemplates,
} from "../../../../../../../services/selfAssessment.service";
import { CoachSelectionView } from "./pages/Components/CoachSelectionView";
export function CVCheckPopup({
  isOpen,
  checkType,
  close,
}: {
  isOpen: boolean;
  checkType: "Basic" | "Plus";
  close: () => void;
}) {
  const [currentPage, setCurrentPage] = useState(0);

  const [selectedTemplate, setSelectedTemplate] = useState(0);
  const [CVToUpload, setCVToUpload] = useState(null);
  const { t } = useTranslation("myArea");

  const [isSelectingCoach, setIsSelectingCoach] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState<CvCheckCoach | null>(null);

  const { data: templates } = useQuery(["templates"], getAvailableTemplates);

  const {
    data: coaches,
    isLoading: isLoadingCoaches,
    error: coachesError,
  } = useQuery<CvCheckCoach[]>("cvCheckCoaches", fetchCvCheckCoaches, {
    staleTime: 300000,
    enabled: isOpen && checkType === "Plus",
  });

  useEffect(() => {
    if (isOpen && checkType === "Plus") {
      if (coaches && coaches.length > 0 && selectedCoach === null) {
        setSelectedCoach(coaches[0]);
      }
    } else {
      setSelectedCoach(null);
      setIsSelectingCoach(false);
    }
    if (!isOpen) {
      setCurrentPage(0);
      setCVToUpload(null);
    }
  }, [checkType, coaches, selectedCoach, isOpen]);

  const canChangeCoach = useMemo(
    () => checkType === "Plus" && coaches && coaches.length > 1,
    [checkType, coaches]
  );

  const generatePageTexts = (pageName: any) => {
    if (isSelectingCoach && checkType === "Plus" && pageName === pageNames[2]) {
      return {
        title: t("assessments.cv-check.selectCoachTitle"),
        description: t("assessments.cv-check.selectCoachDesc"),
      };
    }
    return {
      title: t(`assessments.cv-check.${checkType}.${pageName}.title`),
      description: t(
        `assessments.cv-check.${checkType}.${pageName}.description`
      ),
    };
  };

  const pageNames = [
    "template-selector",
    "cv-uploader",
    "template-preview",
    "success",
  ];

  const currentViewIndex =
    isSelectingCoach && checkType === "Plus" ? 2 : currentPage;
  const title = generatePageTexts(pageNames[currentPage]).title;
  const description = generatePageTexts(pageNames[currentPage]).description;

  const pages = [
    <TemplateSelector
      selectedTemplate={selectedTemplate}
      setSelectedTemplate={setSelectedTemplate}
      onSelect={() => setCurrentPage(1)}
      templates={templates}
    />,
    <CVUploader
      onNext={() => setCurrentPage(2)}
      onBack={() => setCurrentPage(0)}
      setCVToUpload={setCVToUpload}
      cvToUpload={CVToUpload}
    />,

    isSelectingCoach && checkType === "Plus" ? (
      <CoachSelectionView
        key="page-2-coach"
        coaches={coaches}
        selectedCoach={selectedCoach}
        isLoading={isLoadingCoaches}
        error={coachesError}
        onSelectCoach={(coach: any) => {
          setSelectedCoach(coach);
          setIsSelectingCoach(false);
        }}
        onBack={() => setIsSelectingCoach(false)}
      />
    ) : (
      <TemplatePreview
        key="page-2-preview"
        selectedTemplate={selectedTemplate}
        cvToUpload={CVToUpload}
        templates={templates}
        checkType={checkType}
        deleteFile={() => {
          setCVToUpload(null);
          setCurrentPage(1);
        }}
        deleteTemplate={() => {
          setCurrentPage(0);
        }}
        selectedCoach={selectedCoach}
        isLoadingCoaches={isLoadingCoaches}
        canChangeCoach={canChangeCoach}
        onTriggerCoachSelection={() => setIsSelectingCoach(true)}
        onNext={() => setCurrentPage(3)}
        onBack={() => setCurrentPage(1)}
      />
    ),

    // <TemplatePreview
    //   onNext={() => setCurrentPage(3)}
    //   onBack={() => setCurrentPage(1)}
    //   selectedTemplate={selectedTemplate}
    //   cvToUpload={CVToUpload}
    //   templates={templates}
    //   checkType={checkType}
    //   deleteFile={() => {
    //     setCVToUpload(null);
    //     setCurrentPage(1);
    //   }}
    //   deleteTemplate={() => {
    //     setCurrentPage(0);
    //   }}
    // />,
    <SuccessPage
      onClose={() => {
        close();
        setCurrentPage(0);
      }}
    />,
  ];

  return (
    <PopupWrapper isOpen={isOpen}>
      <div className="bg-white lg:rounded-md lg:w-1/3 p-6 w-full h-full lg:h-auto overflow-y-auto">
        <div className="flex justify-between items-center mb-3">
          <span className="text-lg font-bold">{title}</span>
          <CloseIcon
            onClick={() => {
              close();
              setCurrentPage(0);
            }}
          />
        </div>
        <span>{description}</span>
        <div>{pages[currentPage]}</div>
      </div>
    </PopupWrapper>
  );
}
